<template>
  <div id="sectionPrint" class="image-section-root">
    <div class="container">
      <invoice-header
        :orderInfo="data"
        :class="hidden ? 'print:flex hidden' : ''"
        class="mb-3"
      ></invoice-header>

      <div class="section-info">
        <div class="section-card rounded-md p-2 border border-gray-300 relative text-sm">
          <div
            class="title font-bold mb-4 absolute -top-3 px-5 right-5 bg-indigo-50"
          >
            {{ sectionTitle }}
          </div>

          <div
            class="img-grid"
            :style="{ '--cols': cols, '--rows': rows }"
          >
            <div
              v-for="(img, i) in images"
              :key="i"
              class="img-cell"
            >
              <img
                :src="img.image"
                class="img-photo"
                :alt="'صورة ' + (i + 1)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import invoiceHeader from "./OrderInfo";

export default {
  props: {
    data: Object,
    images: Array,
    sectionTitle: String,
    hidden: Boolean,
  },
  components: { invoiceHeader },

  computed: {
    /** 2-column layout, calculate rows from image count */
    cols() {
      const count = (this.images || []).length;
      return count === 1 ? 1 : 2;
    },
    rows() {
      const count = (this.images || []).length;
      return Math.max(1, Math.ceil(count / this.cols));
    },
  },
};
</script>

<style scoped>
/* ── Root: fills the parent page container ── */
.image-section-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.image-section-root > .container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ── Section stretches to fill remaining space ── */
.section-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.section-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ── Grid: columns & rows driven by CSS vars ── */
.img-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  grid-template-rows: repeat(var(--rows), 1fr);
  gap: 10px;
  padding: 6px;
  min-height: 0;
}

/* ── Each cell ── */
.img-cell {
  overflow: hidden;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  transition: transform 0.2s, box-shadow 0.2s;
}

.img-cell:hover {
  transform: scale(1.01);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1;
  position: relative;
}

/* ── Image: contain = full image, no cropping ── */
.img-photo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
}

/* ── Print overrides ── */
@media print {
  .image-section-root {
    overflow: hidden;
  }

  .img-grid {
    gap: 6px;
    padding: 4px;
  }

  .img-cell {
    border-radius: 6px;
    page-break-inside: avoid;
  }

  .img-cell:hover {
    transform: none;
    box-shadow: none;
  }

  .img-photo {
    border-radius: 5px;
  }
}
</style>
